import React from 'react'

const LoadingScreenComponent = () => (
    <div className="loadingScreen" style={{width:'100%',textAlign:'center',marginTop:'25%'}} >
        <img src={'/images/icon-loader.svg'} alt={"loading"} />
    </div>
)

export default LoadingScreenComponent


// WEBPACK FOOTER //
// ./src/LoadingScreen.js